export enum PaymentTemplate {
  default = 'DEFAULT',
  swissQrWithReferenceNr = 'SWISS_QR_WITH_REFERENCE_NR',
  swissQrWithoutReferenceNr = 'SWISS_QR_WITHOUT_REFERENCE_NR'
}
